import { setTerm } from './helpers';

export const setJsonQueryPriceType = setTerm('price_type');
